import R from 'ramda'
import {defineMessages} from 'react-intl'

import addNotification from './addNotification'

import fetchDirections from '../api/fetchDirections'

import {poiToApi} from '../utils/apiMapper'
import directionsToPolylines from '../utils/directionsToPolylines'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "The directions between your points of interest and this estate could not be retrieved, try again later", 
    defaultMessage: "The directions between your points of interest and this estate could not be retrieved, try again later"
  }
})
const notification = {type: "error", message: messages.message, title: messages.title} 

const onComplete = dispatch => (err, directions) => {
  if(err) {
    dispatch(addNotification(notification))
    return console.error("failed to fetch directions", err)
  }

	var directions2 = [];
	for(var i in directions){
		if(directions[i].isReverse){
			directions2.push(directions[i]);	
		}	
	}

  const paths = directionsToPolylines(directions2)
	console.log(paths)
  dispatch({type: 'load_paths', paths})
}

export default (query, estateId) => (dispatch, getState) => {
  const pois = R.filter(poi => !poi.type, query.pois)
  const apiPois = R.map(poiToApi, pois)
  const state = getState()
  
  //XXX the selection process come after this action
  if(state.selectedEstateId != estateId){
    fetchDirections(estateId, apiPois, onComplete(dispatch))
  }else {
    onComplete(dispatch)(null, [])
  }
}



/** WEBPACK FOOTER **
 ** ./app/actions/fetchDirections.js
 **/